import { createRouter, createWebHistory } from 'vue-router'

import HomePage from '@/views/HomePage.vue'
import BlogListPage from '@/views/BlogListPage.vue'
import BlogPostPage from '@/views/BlogPostPage.vue'
import SolutionsPage from '@/views/SolutionsPage.vue'
import ProjectsPage from '@/views/ProjectsPage.vue'
import SolutionTemplates from '@/views/SolutionTemplates.vue'

import DashboardFinanceiroView from '@/views/templates/DashboardFinanceiroView.vue'
import CrmPipelineView from '@/views/templates/CrmPipelineView.vue'
import CentralAtendimentoView from '@/views/templates/CentralAtendimentoView.vue'
import AgenteIaView from '@/views/templates/AgenteIaView.vue'
import BackofficeOperacionalView from '@/views/templates/BackofficeOperacionalView.vue'
import AgendaConsultorioView from '@/views/templates/AgendaConsultorioView.vue'
import PortalClienteView from '@/views/templates/PortalClienteView.vue'
import LandingPageView from '@/views/templates/LandingPageView.vue'
import HubIntegracoesView from '@/views/templates/HubIntegracoesView.vue'
import PainelExecutivoView from '@/views/templates/PainelExecutivoView.vue'
import AutomacaoProcessosView from '@/views/templates/AutomacaoProcessosView.vue'
import SaasMvpView from '@/views/templates/SaasMvpView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage
  },

  {
    path: '/solutions',
    name: 'solutions',
    component: SolutionsPage
  },

  {
    path: '/blog',
    name: 'blog',
    component: BlogListPage
  },

  {
    path: '/blog/:slug',
    name: 'post',
    component: BlogPostPage,
    props: true
  },

  {
    path: '/projects',
    name: 'projects',
    component: ProjectsPage
  },

  {
    path: '/templates',
    name: 'templates',
    component: SolutionTemplates
  },

  {
    path: '/templates/dashboard-financeiro',
    name: 'template-dashboard-financeiro',
    component: DashboardFinanceiroView
  },

  {
    path: '/templates/crm-pipeline',
    name: 'template-crm-pipeline',
    component: CrmPipelineView
  },

  {
    path: '/templates/central-atendimento-whatsapp',
    name: 'template-central-atendimento',
    component: CentralAtendimentoView
  },

  {
    path: '/templates/agente-ia',
    name: 'template-agente-ia',
    component: AgenteIaView
  },

  {
    path: '/templates/backoffice-operacional',
    name: 'template-backoffice-operacional',
    component: BackofficeOperacionalView
  },

  {
    path: '/templates/agenda-consultorio',
    name: 'template-agenda-consultorio',
    component: AgendaConsultorioView
  },

  {
    path: '/templates/portal-cliente',
    name: 'template-portal-cliente',
    component: PortalClienteView
  },

  {
    path: '/templates/landing-page',
    name: 'template-landing-page',
    component: LandingPageView
  },

  {
    path: '/templates/hub-integracoes',
    name: 'template-hub-integracoes',
    component: HubIntegracoesView
  },

  {
    path: '/templates/painel-executivo',
    name: 'template-painel-executivo',
    component: PainelExecutivoView
  },

  {
    path: '/templates/automacao-processos',
    name: 'template-automacao-processos',
    component: AutomacaoProcessosView
  },

  {
    path: '/templates/saas-mvp',
    name: 'template-saas-mvp',
    component: SaasMvpView
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior() {
    return { top: 0 }
  }
})

export default router